import React from "react";
import PreBuiltSolutions from "../components/product/PreBuiltSolutions";
import DMS from "../components/product/DMS";
import KeyFeatures from "../components/product/KeyFeatures";
import ConsultationForm from "../components/product/ConsultationForm";
import SalesBoostCard from "../components/product/SalesboostCard";
import DMSComponent from "../components/product/DMSComponent";
import '../components/product/Index.css'

const Products = () => {
  return (
    <div >
      <DMS />
      <SalesBoostCard />
      <KeyFeatures />
      <DMSComponent />
      <PreBuiltSolutions />
      <ConsultationForm />
    </div>
  );
};

export default Products;

